import React from 'react';
import { Button } from '@mui/material';

/**
 * A controlled component that displays a list of clickable items
 */
const ClickableList = ({
  type,
  values,
  valueLookup,
  emptyComponent,
  onClick = () => {},
  nameRenderer = null,
  nameField = 'name',
}) => {
  const renderer = nameRenderer ?? ((v) => v[nameField]);
  return values.length > 0 ? (
    <div>
      {values
        .map((val) => valueLookup[val] ?? val)
        .map((v) => {
          const id = v?.id ?? v;
          return (
            <Button key={id} variant="outlined" onClick={() => onClick(id)}>
              {Number.isInteger(v) ? `Unpublished ${type} ${id}` : renderer(v)}
            </Button>
          );
        })}
    </div>
  ) : (
    emptyComponent
  );
};

export default ClickableList;
